<template>
	<div class="center-page-minus immerse-wrap">
		<div class="immerse-content">
			<StepBar :step="0" />
			<div class="left">
				<h3 class="title">我的購物車</h3>
			</div>
			<ByCartGrid />
		</div>
		<div style="height: 56px" />
		<ByOrderControl
			:names="['回菜單', '下一步']"
			:events="[goStore, next]"
			:loadings="[false, isNextLoading]"
		/>
		<ByCompareCartConfirm ref="compareCartConfirmRef" />
		<PickupMethodDialog
			v-model="isPickupMethodShowing"
			width="100%"
			title="選擇取餐方式和時間"
			@cancel="handleCancelPickupMethod"
			@confirm="handlePickUpConfirm"
		/>
	</div>
</template>

<script>
import StepBar from '../layout/StepBar'
import PickupMethodDialog from '@/components/PickupMethodDialog.vue'

export default {
	components: {
		StepBar,
		PickupMethodDialog,
	},
	data() {
		return {
			isNextLoading: false,
			isPickupMethodShowing: false,
		}
	},
	computed: {
		qrCodeHash() {
			return this.$storeManager.qrCodeHash
		},
		cart() {
			const cart = this.$store.getters['user/currCart'](this.qrCodeHash)
			return cart || []
		},
	},
	watch: {
		cart() {
			if (this.cart.length === 0 && this.$refs.compareCartConfirmRef.isShow) {
				this.$router.push(`/${this.qrCodeHash}/Store`)
			}
		},
	},
	methods: {
		goStore() {
			this.$router.push(`/${this.qrCodeHash}/Store`)
		},
		handleCancelPickupMethod() {
			// 取消選擇取餐方式時的處理（目前無需特別處理）
		},
		handlePickUpConfirm(pickUpDraft) {
			this.$store.dispatch('user/confirmPickupMethod', pickUpDraft)
		},
		checkIsOverMinAmount() {
			const minAmount =
				this.$store.state.store?.openInfo?.mobilePickupMethod?.delivery
					?.deliveryMinimumAmount
			const cartTotal =
				this.$store.getters['user/cartTotal'](this.qrCodeHash) || 0
			return cartTotal >= minAmount
		},
		async next() {
			this.isNextLoading = true

			// NOTE: 表單的驗證在送出時已經做掉了，但是還沒有防禦沒有取餐方式。因此在送出前處理這邊的情況
			const isMethodPickedUp = !!this.$store.state.user.pickUpMethod
			if (!isMethodPickedUp) {
				this.isPickupMethodShowing = true
				this.isNextLoading = false
				return
			}

			const pickUpMethod = this.$store.state.user.pickUpMethod
			if (pickUpMethod === 'DELIVERY' && !this.checkIsOverMinAmount()) {
				this.$alert('您選購的餐點尚未達最低外送金額，請前往加點。', 'danger')
				this.isNextLoading = false
				return
			}

			try {
				await this.$refs.compareCartConfirmRef.confirm()
			} finally {
				this.isNextLoading = false
			}
		},
	},
}
</script>

<style lang="sass" scoped>
.left
  h3
    text-align: left
    padding-left: 20px
    &.title
      margin: 0
      padding-top: 30px
      padding-bottom: 30px
      border-bottom: 1px solid #D8D8D899

.center-page-minus
  padding: 0

  @media screen and (min-width: 600px)
    margin-bottom: 75px
    padding: initial

.immerse-content
  @media screen and (min-width: 600px)
    width: 425px
    flex: 1
    margin-bottom: 0
</style>
